
export enum InstructionStatCd {
	CANCELLED = 'Cancelled',
	COMPLETED = 'Completed',
	IN_PROGRESS = 'InProgress',
	PENDING = 'Pending'}

